import styled from "@emotion/styled";
import { rem } from "polished";
import React from "react";
import {
  ChainMismatchError,
  ConnectorNotFoundError,
  UserRejectedRequestError,
} from "wagmi";

import Strings from "../lib/strings";

const Alert = styled.div`
  width: 100%;
  padding: ${rem(10)};
  border-radius: 0.8rem;
  background-color: rgba(255, 0, 0, 0.03);
  font-size: ${rem(14)};
  line-height: ${rem(20)};
  color: rgba(88, 0, 0, 1);
  text-align: center;
`;

const ExternalLink = styled.a`
  color: #000;
`;

interface ErrorProps {
  error: Error | any | string;
  message?: React.ReactElement | string;
}

const parseErrorMessage = (err: any) => {
  let errMsg;

  if (err.message) {
    errMsg = err.message;
  } else {
    errMsg = `${err}`;
  }

  if (errMsg.includes("User denied transaction signature")) {
    errMsg = "Transaction rejected";
  } else if (errMsg.includes("Insufficient balance")) {
    errMsg = "Insufficient balance";
  } else if (errMsg.includes("reverted by the EVM")) {
    errMsg = "Reverted";
  }
  return errMsg;
};

const ErrorBox = ({ error, message }: ErrorProps) => {
  if (!error) {
    return null;
  }

  switch (error.constructor) {
    case ChainMismatchError: {
      return (
        <Alert>
          You are connected to an unsupported Ethereum network. Please connect
          to {Strings.supportedNetworkNames}.
        </Alert>
      );
    }
    case ConnectorNotFoundError: {
      return (
        <Alert>
          We could not locate a supported web3 browser extension.
          <br />
          We recommend using MetaMask.{" "}
          <ExternalLink href="https://metamask.io/">
            Download MetaMask here.
          </ExternalLink>
        </Alert>
      );
    }
    case UserRejectedRequestError: {
      return (
        <Alert>
          Account authorization declined. Please try again and allow access.
        </Alert>
      );
    }
  }

  return <Alert>{parseErrorMessage(error) ?? message}</Alert>;
};

export default ErrorBox;
